// eslint-disable-next-line no-restricted-imports
import type { Logger } from '@glovo/logger'
// eslint-disable-next-line no-restricted-imports
import { LogLevel, createStdOutLogger, defineLogger, withScope } from '@glovo/logger'
import { context, trace } from '@opentelemetry/api'
import { getConfig } from '@/tools/config'

const SAMPLE_RATE = 1
const MIN_LOG_LEVEL = LogLevel.INFO

export const getStdOutIntegration = (): Logger<string> => {
  const { env, version, isBrowser, name } = getConfig()

  const logger = defineLogger({
    factory: () => createStdOutLogger(console),
    config: { minLogLevel: MIN_LOG_LEVEL, samplingRate: SAMPLE_RATE },
  })

  const loggerWithScope = withScope(
    {
      appVersion: version,
      env: env,
      environment: env,
      platform: 'web',
      service: name,
      processType: isBrowser ? 'client' : 'server',
    },
    logger
  )

  return withScope(() => {
    const span = trace.getSpan(context.active())
    if (!span) {
      return {}
    }

    const spanContext = span.spanContext()
    return {
      traceId: spanContext.traceId,
      spanId: spanContext.spanId,
    }
  }, loggerWithScope)
}
